module.exports = __webpack_public_path__ + "img/check-penalty.cdd7e5b7.svg";